"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useToggleMenuHandler = void 0;
var _toggleMenuFlyout = require("@ori-events/toggle-menu-flyout");
var _presentationHooks = require("@ori/presentation-hooks");
var _react = require("react");
var _activeMenuContext = require("../context/navigation/activeMenuContext");
const useToggleMenuHandler = () => {
  const {
    toggleActiveMenu
  } = (0, _activeMenuContext.useActiveMenu)();
  const onToggle = (0, _react.useCallback)(event => toggleActiveMenu(event.detail.menuType), [toggleActiveMenu]);
  const events = (0, _react.useMemo)(() => [{
    name: _toggleMenuFlyout.Name,
    listener: onToggle
  }], [onToggle]);
  (0, _presentationHooks.useGlobalEvents)(events);
};
exports.useToggleMenuHandler = useToggleMenuHandler;
